import React from 'react'
import { PropTypes } from 'prop-types'
import styled, { css } from 'styled-components'

import { HeroWrapper } from '../../../styles/Wrappers'

const Wrapper = styled(HeroWrapper)`
	display: block;

	${({ colorlist }) =>
		colorlist &&
		css`
			background-image: linear-gradient(90deg, ${colorlist.value} 0%, ${colorlist.light} 100%);
		`}
	svg {
		vertical-align: bottom;
	}
`

const FancyWave = ({ colorlist }) => (
	<Wrapper colorlist={colorlist}>
		<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="30 0 1200 155">
			<g fill="none">
				<g>
					<g fill="#FFFFFF">
						<path
							className="st1"
							opacity="0.27"
							d="M1298.5,42.6v169.6H4.3V33.5c3.6-0.4,7.1-0.8,10.7-1.3c5.5-0.7,11.1-1.5,16.6-2.1
				c111.9-13.6,226.8-13.6,338.7,0c92.6,11.3,182.6,31.7,274.5,45.6c1.6,0.2,3.3,0.5,5,0.7c20.9,3.1,41.8,5.9,62.9,8.3
				c35.2,4.1,71.8,7.8,108.9,10.5c68.5,5.1,138.9,6.8,205.5,1.2c13.4-1.1,26.6-2.5,39.6-4.3c55.6-7.4,110.4-16.8,164-30.3
				c11.4-2.9,22.8-5.9,34-9.1C1276.1,49.5,1287.4,46.1,1298.5,42.6z"
						/>
						<path
							className="st2"
							fill="#FFFFFF"
							opacity="0.28"
							d="M1294.2,29v155H0V0c9.1,0.5,18.2,1.2,27.3,2c4.9,0.4,9.9,0.8,14.8,1.3c147.1,13.7,289.7,52.4,435,70.9
				c54.4,7,109.3,11.1,164.8,10.1c59.3-1.1,117.5-8.1,175.4-17.1c37-5.8,73.8-12.3,110.8-18.7c21.4-3.7,42.9-7.3,64.4-10.6
				c87.7-13.6,179.9-22.4,268-13.2C1271.8,25.8,1283,27.2,1294.2,29z"
						/>
					</g>
				</g>
				<path
					className="st3"
					fill="#F5FAEA"
					d="M1294.2,138.1v46H0V87.9c3.2,1,6.3,2,9.5,3c11.5,3.6,23.1,7,34.8,10.3c54.8,15.5,111.4,27.2,169.1,37.2
		c13.5,2.3,27.3,4.4,41.2,6.2c69.4,8.9,143.6,11.4,216.1,10.6c39.3-0.4,78.2-1.7,115.5-3.4c22.4-1,44.7-2.4,66.9-4
		c1.8-0.1,3.5-0.3,5.3-0.4c98-7.6,194.8-21.3,293.3-26.4C1066.1,115,1182.2,120.8,1294.2,138.1z"
				/>
			</g>
		</svg>
	</Wrapper>
)

export default function VSMWave({ colorlist }) {
	return <FancyWave colorlist={colorlist} />
}

VSMWave.propTypes = {
	colorlist: PropTypes.object,
}
